import { useRef, useEffect, useState } from 'react';

import { DateTime, Settings } from 'luxon';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import {
    HEADER_MIN,
    HEADER_SPECIAL_DATE,
    HEADER_ORDER,
} from '~/src/config/constants';
import isDisplayHeadbandOrder from '~/src/lib/isDisplayHeadbandOrder';
import useOnScreen from '~/src/hooks/useOnScreen';
import translateMsg from '~/src/lib/translateMsg';
import getFilteredOrders from '~/src/lib/getFilteredOrders';
import getClosingDate from '~/src/lib/getClosingDate';
import getSpecialDateText from '~/src/lib/getSpecialDateText';

function App(props) {
    const router = useRouter();

    const business = useSelector((state) => state.business);
    const lang = useSelector((state) => state.lang);
    const user = useSelector((state) => state.user);
    const orders = useSelector((state) => state.order);
    const todayOrder = getFilteredOrders(orders, {
        today: true,
        status: 'not_delivered',
    });

    const [closingDate, setClosingDate] = useState(false);

    // Ref for the element that we want to detect whether on screen
    const ref = useRef();
    // Call the hook passing in ref and root margin
    // In this case it would only be considered onScreen if more ...
    // ... than 300px of element is visible.
    const onScreen = useOnScreen(ref, '0px');

    useEffect(() => {
        setClosingDate(getClosingDate(business));
        const interval = setInterval(() => {
            setClosingDate(getClosingDate(business));
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    //console.log(1111111111);
    //console.log(onScreen);

    if (closingDate === false) {
        return false;
    }

    const _handleFloatingCartTop = () => {
        const elem = document.getElementById('floatingCart');
        if (elem) {
            let h = HEADER_MIN + 10;

            if (onScreen) {
                h = h + HEADER_SPECIAL_DATE;
            }

            if (isDisplayHeadbandOrder(business, orders, router) === true) {
                h = h + HEADER_ORDER;
            }

            elem.style.top = `${h}px`;
        }
    };

    _handleFloatingCartTop();
    //_handleTabsTop();

    const text = getSpecialDateText(closingDate, lang);

    return (
        <div
            ref={ref}
            id="special-closure-block"
            style={{
                height: HEADER_SPECIAL_DATE,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div class="special-closure-block-title">{text}</div>
        </div>
    );
}

export default App;
